module.exports = __webpack_public_path__ + "static/media/3.34022fc0.PNG";